import { Component, Input } from '@angular/core';
import { FileSequenceInstance, FileSequenceTemplate } from 'app/types';

@Component({
  selector: 'side-panel-file-sequence',
  templateUrl: './side-panel-file-sequence.component.html',
  styleUrl: './side-panel-file-sequence.component.scss',
})
export class SidePanelFileSequenceComponent {
  @Input() instance: FileSequenceInstance | null = null;
  @Input() template: FileSequenceTemplate | null = null;

  tooltipName(instance: FileSequenceInstance): string {
    return instance.properties
      .map((prop) => `${prop.name}: ${prop.option_name ?? '---'}`)
      .join('\n');
  }

  inlineName(instance: FileSequenceInstance): string {
    return instance.properties
      .filter((prop) => prop.option_id !== null)
      .map((prop) => prop.option_name)
      .join(' - ');
  }
}
